import { isDate } from 'lodash';
import { formatDate, DATE_FORMATS } from 'component-utilities/dates/dates';

export default function generateDatePickerRangeProps({
  onSelectedValue,
  datepickerObject,
  getMessage,
  isPcc
}) {
  const generalDatePickerProps = {
    type: 'small',
    onSelectedValue,
  };
  const datepickerProps = {};
  const prefix = () => {
    if(isPcc){
      return 'pcc';
    }

    return 'app';
  };

  ['from', 'to'].forEach((datetype) => {
    const date = datepickerObject[datetype];
    const value = isDate(date) ? formatDate(date, DATE_FORMATS.SHORT) : '';
    const placeholder = getMessage(
      datetype === 'from'
        ? `${prefix()}.placeholder.from_date`
        : `${prefix()}.placeholder.to_date`,
    );

    datepickerProps[datetype] = {
      styleName: `dropdown-inline-${datetype}`,
      placeholder,
      datepickerOptions: {
        widgetId: datetype,
      },
      widgetId: datetype,
      selectedValue: { date, value },
      ...generalDatePickerProps,
    };
  });

  if (isDate(datepickerObject.from)) {
    datepickerProps.to.datepickerOptions.minDate = datepickerObject.from;
  }

  if (isDate(datepickerObject.to)) {
    datepickerProps.from.datepickerOptions.maxDate = datepickerObject.to;
  }

  return datepickerProps;
}
